import React from 'react';
import { useGetEpdScrapInputs, useGetEpdShareOfTotalScrapInput } from 'services/api/queries';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { HeaderCaptionSemiBold } from 'styles/v2/Styles.styled';
import { ColumnFooterInputNumber, DataTableStyled } from '../StyledGrid';

const ContributionOfScrapInputsGridPdf: React.FunctionComponent<{ epdVersionId: string; className?: string }> = ({
  epdVersionId,
  className,
}) => {
  const shareOfTotalScrapInput = useGetEpdShareOfTotalScrapInput(epdVersionId!).data;

  const scrapInputs = useGetEpdScrapInputs(epdVersionId!).data;

  const header = (
    <div className="flex flex-wrap align-items-center justify-content-between gap-2">
      <HeaderCaptionSemiBold className="white-space-nowrap">Scrap (recycled material) inputs data</HeaderCaptionSemiBold>
    </div>
  );

  const footerNumberEditor = () => (
    <ColumnFooterInputNumber
      value={shareOfTotalScrapInput?.sharePercent}
      suffix=" %"
      mode="decimal"
      step={0.01}
      maxFractionDigits={2}
      disabled
    />
  );

  const footerGroup = (
    <ColumnGroup>
      <Row style={{ borderTop: 'none' }}>
        <Column
          footer={<div>The share of the total scrap input that was assumed to come with an environmental burden</div>}
          className="p-row-note"
        />
        <Column footer={footerNumberEditor} colSpan={4} className="p-row-note" />
      </Row>
    </ColumnGroup>
  );

  const formatScrapInputValue = (value: number | undefined) =>
    value !== null && value !== undefined ? (
      <>
        {value}, kg CO<sub>2</sub> eq./tonne
      </>
    ) : null;

  const areScrapInputsEmpty =
    !scrapInputs || scrapInputs.length === 0 || (scrapInputs.length === 1 && !scrapInputs[0].name && !scrapInputs[0].value);

  const isShareOfTotalScrapInputEmpty = !shareOfTotalScrapInput || !shareOfTotalScrapInput.sharePercent;

  if (areScrapInputsEmpty && isShareOfTotalScrapInputEmpty) {
    return null;
  }

  return (
    <DataTableStyled
      className={className}
      dataKey="id"
      header={header}
      footerColumnGroup={footerGroup}
      value={scrapInputs}
      showGridlines
    >
      <Column field="name" header="Material scrap name" />
      <Column field="value" header="Material scrap value" body={(rowData) => formatScrapInputValue(rowData.value)} />
    </DataTableStyled>
  );
};

export default ContributionOfScrapInputsGridPdf;
